export var PWAReducerName = '@pwa/pwa-state';
